import { cn } from "@design-system/lib/utils";
import { trans } from "@mongez/localization";
import { GraduationCapIcon, SparklesIcon } from "lucide-react";
import type { GradeDetailsTheme } from "../../hooks/use-grade-details-page.hook";

type GradeDetailsEmptyStateProps = {
  theme: GradeDetailsTheme;
};

export function GradeDetailsEmptyState({
  theme,
}: GradeDetailsEmptyStateProps) {
  return (
    <div className="relative overflow-hidden rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-16 text-center dark:border-slate-700 dark:bg-slate-900">
      <div
        className={cn(
          "absolute -top-20 start-1/2 size-52 -translate-x-1/2 rounded-full blur-3xl",
          theme.glow,
        )}
      />
      <div
        className={cn(
          "relative mx-auto mb-5 flex size-20 items-center justify-center rounded-[1.75rem] bg-gradient-to-br text-white shadow-xl",
          theme.gradient,
        )}
      >
        <GraduationCapIcon className="size-10" />
        <SparklesIcon className="absolute -end-2 -top-2 size-6 rounded-full bg-white p-1 text-amber-500 shadow" />
      </div>
      <h2 className="relative text-xl font-black text-slate-950 dark:text-white sm:text-2xl">
        {trans("grades.noCategoriesAvailable")}
      </h2>
      <p className="relative mx-auto mt-2 max-w-xl text-sm leading-7 text-slate-500 dark:text-slate-400 sm:text-base">
        {trans("grades.noCategoriesAvailableMessage")}
      </p>
    </div>
  );
}

